import { render } from "./CheckReceipt.vue?vue&type=template&id=35b2754e"
import script from "./CheckReceipt.vue?vue&type=script&lang=js"
export * from "./CheckReceipt.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\tansi\\OneDrive\\Desktop\\all\\quitrent\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__